import {Injectable} from '@angular/core';
import {Mixture, mixtures} from "../data/mixtures";

@Injectable({
  providedIn: 'root'
})
export class MixtureService {

  constructor() {
  }

  getMixtures() {
    return mixtures
  }

  getSimilarByPressure(pressure: number): Mixture[] {
    let minusRange = -0.2
    let plusRange = 0.2

    if (pressure > 5.70 && pressure < 6.5) {
      minusRange = parseFloat((5.5 - pressure).toFixed(1))
    } else if (pressure >= 6.5) {
      plusRange = parseFloat((7.8 - pressure).toFixed(1))
    }

    const from = parseFloat((pressure + minusRange).toFixed(1))
    const to = parseFloat((pressure + plusRange).toFixed(1))

    return mixtures.filter(mixture => mixture.bar >= from && mixture.bar <= to)
  }

  getSimilarByValues(propane: number, isoButane: number, nButane: number, pressure: number) {
    const percentRange = 10

    return mixtures.filter(mixture => {
      return (
        (mixture.propane >= (propane - percentRange) && mixture.propane <= (propane + percentRange)) &&
        (mixture.isobutane >= (isoButane - percentRange) && mixture.isobutane <= (isoButane + percentRange)) &&
        (mixture.butane >= (nButane - percentRange) && mixture.butane <= (nButane + percentRange))
      ) || (mixture.bar == parseFloat(pressure.toFixed(2)))
    })
  }

  calculatePressure(propane: number, isoButane: number, nButane: number) {
    return parseFloat(((propane * 7.8 + isoButane * 2.1 + nButane * 1.2) / 100).toFixed(1))
  }

  getMixtureById(mixtureId: any) {
    return mixtures.find(mixture => mixture.id === mixtureId)
  }

  getMixtureByName(name: string) {
    return mixtures.find(mixture => mixture.name === name)
  }

  findProductsForPressure(pressure: number) {
    const matchingProducts = []
    const similarProducts = []

    const mixtures = this.getSimilarByPressure(pressure)

    for (const mixture of mixtures) {
      if (mixture.bar === pressure) {
        matchingProducts.push(mixture)
      } else {
        similarProducts.push(mixture)
      }
    }

    similarProducts.sort((a, b) => {
      const v1 = Math.abs(a.bar - pressure)
      const v2 = Math.abs(b.bar - pressure)

      if (v1 > v2) {
        return 1
      } else if (v2 < v1) {
        return -1
      }

      return 0
    })

    return {matchingProducts, similarProducts}
  }

  findProductsForValues(propane: number, isoButane: number, nButane: number, pressure: number) {
    const matchingProducts = []
    const similarProducts = []

    const mixtures = this.getSimilarByValues(propane, isoButane, nButane, pressure)

    for (const mixture of mixtures) {
      if (mixture.propane === propane && mixture.isobutane === isoButane && mixture.butane === nButane) {
        matchingProducts.push(mixture)
      } else {
        similarProducts.push(mixture)
      }
    }

    similarProducts.sort((a, b) => {
      const v1 = Math.abs(a.propane - propane) + Math.abs(a.isobutane - isoButane) + Math.abs(a.butane - nButane)
      const v2 = Math.abs(b.propane - propane) + Math.abs(b.isobutane - isoButane) + Math.abs(b.butane - nButane)


      return v1 - v2
    })

    return {matchingProducts, similarProducts}
  }
}
